import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export default function FaqAccordion({ faqs, idPrefix = "faq" }) {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
      {faqs.map((f, i) => (
        <AccordionItem key={i} value={`${idPrefix}-${i}`} className="border-b border-slate-200">
          <AccordionTrigger
            data-testid={`${idPrefix}-q-${i}`}
            className="text-left font-heading font-semibold text-navy hover:text-royal text-base py-4"
          >
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-sm text-slate-600 leading-relaxed pb-4">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
